import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../store/selectors/UserSelectors";
import { UserType } from "../../entities/User";
import { Col, Row } from "react-bootstrap";
import PageTitle from "../../components/Ui/PageTitle";
import OrderList from "../../components/OrderList";
import OrderTypeSelector from "../../components/OrderTypeSelector";
import { OrderStatus } from "../../api/endpoints/Order";
import { fetchOrders } from "../../store/action-creators/orders";
import { TRootState } from "../../store/reducers/RootReducer";
import { TOrdersSubState } from "../../store/reducers/orders";
import AdminDashboard from "./AdminDashboard";
import Orders from "../Orders";

const AnonymousUserDashboard = () => {
  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <PageTitle title="Select a product" />
          </Col>
        </Row>

        <OrderTypeSelector />
      </Col>
    </Row>
  );
}

const CCPUserDashboard = () => {
  return (
    <Orders />
  );
}

const CustomerDashboard = () => {
  const dispatch = useDispatch();
  const ordersState = useSelector<TRootState, TOrdersSubState | undefined>(state => state.orders[-1], shallowEqual);

  useEffect(() => {
    dispatch(fetchOrders());
  }, []);

  return (
    <div>
      <h2>Pending orders</h2>
      {
        ordersState &&
        <OrderList
          orders={ordersState.data}
          status={OrderStatus.SUBMITTED}
          loading={!ordersState.error && !ordersState.loadedAt}
          error={Boolean(ordersState.error)}
        />
      }

      <h2>Start new order</h2>
      <OrderTypeSelector />
    </div>
  );
}

const DASHBOARD_BY_USERTYPE = {
  [UserType.Unknown]: AnonymousUserDashboard,
  [UserType.Customer]: CustomerDashboard,
  [UserType.CCP]: CCPUserDashboard,
  [UserType.Admin]: AdminDashboard,
}

const Dashboard = () => {
  const user = useSelector(selectUser);
  const DashboardComponent = DASHBOARD_BY_USERTYPE[user.type];

  return (
    <DashboardComponent />
  )
}

export default Dashboard;
